import { FC } from 'react';
import { RowCell } from '../types/RowCell';

type TableRowProps = {
  cells: RowCell[];
  className?: string;
};

const TableRow: FC<TableRowProps> = ({ cells, className }) => (
  <tr className={className || 'nk-tb-item '}>
    {cells.map((cell) => {
      const {
        key,
        content,
        textPosition = 'left',
        hideOnMobile = false,
        verticalAlignMiddle = true,
        documentCell = false,
        onClick,
      } = cell;

      return documentCell ? (
        content
      ) : (
        <td
          key={key}
          className={[
            onClick ? 'cursor-pointer' : '',
            'nk-tb-col',
            `text-${textPosition}`,
            hideOnMobile && 'tb-col-xl',
            verticalAlignMiddle && 'vertical-align-middle',
            cell?.className || '',
          ]
            .filter(Boolean)
            .join(' ')}
          onClick={onClick}
        >
          {content}
        </td>
      );
    })}
  </tr>
);

export default TableRow;
